export default __webpack_public_path__ + "static/media/maria-vasconcelos-book.58080a8d.png";